// https://dev.to/rounakbanik/building-a-web3-frontend-with-react-340c  // Web3
// https://gabriellazcano.com/blog/react-hooks-give-you-superpowers/    // useContext

import { useState, useEffect, useContext } from "react";
import { ethers } from "ethers";
import { toast } from "react-toastify";

import Button from "@mui/material/Button";

import { Web3Context } from "../../App";
import { walletShort } from "../common/dataShort";

const ConnectWalletButton = () => {
  // const [currentAccount, setCurrentAccount] = useState(null);
  // const { userAuthWallet, setUserAuthWallet } = useContext(Web3Context);
  const { userAuthWallet, setUserAuthWallet, userWallets, setUserWallets } =
    useContext(Web3Context);

  // const { userWallets, setUserWallets } = useContext(Web3Context);

  const { ethereum } = window;

  const checkWalletIsConnected = () => {
    // const { ethereum } = window;

    if (!ethereum) {
      // console.log("Make sure you have Matamask installed!");
      return;
    }
    // else console.log("Metamask is installed! We're ready to go!");
  };

  const connectWalletHandler = async () => {
    // const { ethereum } = window;

    if (!ethereum) {
      toast.error("Please install Matamask!");
    } else {
      try {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });
        // console.log("Accounts: ", accounts);
        if (accounts.length !== 0) {
          setUserAuthWallet(accounts[0]);
          // setUserWallets(accounts);
        } else toast.error("No authorized account found!");
      } catch (e) {
        console.log(e);
      }
    }
  };

  useEffect(() => {
    checkWalletIsConnected();
  }, []);

  useEffect(() => {
    ethereum?.on("accountsChanged", handleAccountChange);
    return () => {
      ethereum?.removeListener("accountsChanged", handleAccountChange);
    };
  }, []);

  const handleAccountChange = (...args) => {
    // you can console to see the args
    const accounts = args[0];
    // if no accounts that means we are not connected
    if (accounts.length === 0) {
      console.log("Please connect to Metamask!");
      // our old data is not current connected account
      // currentAccount account that you already fetched and assume you stored it in useState
    } else if (accounts[0] !== userAuthWallet) {
      // if account changed you should update the currentAccount so you return the updated the data
      // assuming you have [currentAccount,setCurrentAccount]=useState
      // however you are tracking the state currentAccount, you have to update it. in case of redux you have to dispatch update action etc
      setUserAuthWallet(accounts[0]);
    }
  };

  return userAuthWallet ? (
    // userWallets.map((wallet) => <label>{wallet}</label>)
    <span className="wallet">
      Account: <b>{walletShort(userAuthWallet)}</b>
    </span>
  ) : (
    <Button
      variant="outlined"
      className="extraSmall connectWallet"
      onClick={connectWalletHandler}
    >
      Connect Wallet
    </Button>
  );
};

export default ConnectWalletButton;
